export default {
    data() {
        return {
            job:{
                id: null,
                canceled: false,
            },
        }
    },
    computed: {
        startedProcess(){
            return !!this.job.id;
        },
        idProcess(){
            return this.job.id;
        },
        canceledProcess(){
            return this.job.canceled;
        },
    },
    methods: {
        resetJob: function() {
            Object.assign(this.$data.job, this.$options.data().job);
        },
    },
};